import { render, staticRenderFns } from "./LeadVideoCallsCard.vue?vue&type=template&id=f72ef8be&"
import script from "./LeadVideoCallsCard.vue?vue&type=script&lang=js&"
export * from "./LeadVideoCallsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports